<script>
  export let id;
  export let name;
  export let value;
</script>

<!-- used in some forms to send default data -->
<input type="hidden" {id} {name} {value} />
